import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// ---------- Token storage ----------
// Namespaced by tenant slug so multiple tenants can coexist in one browser
// without their sessions colliding. Platform admin token lives in its own slot.
const TENANT_TOKEN_PREFIX = "cc_token__";
const ADMIN_TOKEN_KEY = "cc_admin_token";
const LEGACY_TOKEN_KEY = "cc_access_token"; // pre-multitenant, cleared on any auth op

// Reserved URL segments that are NEVER slugs — used to detect if we're on a
// slug-scoped route vs an admin/public route.
const RESERVED_SEGMENTS = new Set(["", "login", "app", "admin", "static", "api"]);

export function getCurrentSlug() {
  const seg = window.location.pathname.split("/").filter(Boolean)[0];
  if (!seg || RESERVED_SEGMENTS.has(seg)) return null;
  return seg;
}

export const tokenStore = {
  getForSlug(slug) { return localStorage.getItem(TENANT_TOKEN_PREFIX + slug); },
  setForSlug(slug, t) { localStorage.setItem(TENANT_TOKEN_PREFIX + slug, t); localStorage.removeItem(LEGACY_TOKEN_KEY); },
  clearForSlug(slug) { localStorage.removeItem(TENANT_TOKEN_PREFIX + slug); },
  getAdmin() { return localStorage.getItem(ADMIN_TOKEN_KEY); },
  setAdmin(t) { localStorage.setItem(ADMIN_TOKEN_KEY, t); localStorage.removeItem(LEGACY_TOKEN_KEY); },
  clearAdmin() { localStorage.removeItem(ADMIN_TOKEN_KEY); },
  // Resolve which token applies for the request happening right now.
  // Tenant token (if URL has a slug and it exists) wins, else admin token.
  getForCurrentContext() {
    const slug = getCurrentSlug();
    if (slug) {
      const t = this.getForSlug(slug);
      if (t) return t;
    }
    return this.getAdmin();
  },
};

// ---------- axios instance ----------
const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = tokenStore.getForCurrentContext();
  if (token) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  // Auto-inject tenant_slug when we're on a slug-scoped route (unless caller
  // already set one explicitly). Backend uses it to resolve tenant scope and
  // enforce isolation.
  const slug = getCurrentSlug();
  if (slug) {
    cfg.params = cfg.params || {};
    if (cfg.params.tenant_slug === undefined) cfg.params.tenant_slug = slug;
  }
  return cfg;
});

export default api;
